
import { defineComponent } from "vue";
import GameRelease from "../../../../_models/GameRelease";

import Editor from "@tinymce/tinymce-vue";
import GameReleaseService from "../../../../services/GameReleaseService";
import FeedbackService from "../../../../services/FeedbackService";
import OnboardingChecklistService from "../../../../services/OnboardingChecklistService";
import ResponseData from "../../../../_models/ResponseData";
import store from "@/store/index";
import { Helper } from "@/utils/Helper";
import GamesDeleteReleaseModal from "../modals/gamesDeleteReleaseModal.vue";

export default defineComponent({
  data: function () {
    return {
      file: "",
      remove: "",
      fileName: "",
      listGameReleases: [],
      feedbackList: [],
      progressList: [],
      gameRelease: {
        ReleaseName: "",
        Version: "",
        ReleaseNotes: "",
      } as GameRelease,
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      previewImage: "",
      isSaving: "Save",
      gameReleaseSelected: 'version',
      selectedTab: 'web',
      displayConfirmDeleteModal: false,
      selectedRelease: "",
      selectedPlatform: "",
    };
  },

  name: 'gamesTabGameReleaseComponent',
  components: {
    editor: Editor,
    GamesDeleteReleaseModal
},
  methods: {
    selectImage() {
      this.$refs.fileInput.click();
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      this.fileName = file[0].name;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    removeFile(item) {
      this.file = this.fileName = this.previewImage = "";
    },

    getReleaseImageInput() {
      let input = this.$refs.fileInput;
      let file = input.files;

      return file[0];
    },

    getGameReleases() {
      if (this.$route.params.gameId !== undefined && this.userData !== "" && this.jwtToken !== "") {
        let gameId = this.$route.params.gameId.toString();

        GameReleaseService.getReleasesList(gameId, this.userData.userId, this.jwtToken)
          .then((response: ResponseData) => {
            if(response.data.length > 0){
              let res = response.data.map(res => { 
                let date = new Date(res.created);
                return {
                  platform: res.platform,
                  releaseName: res.releaseName,
                  version: res.version,
                  createdFormattedDate: date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
                }
              })
              this.listGameReleases = res;
            }else{
              this.listGameReleases = [];
            }
          })
          .catch((error) => {
            console.log(error)
            Helper.endpointErrorHandling(error);
          });
      }
    },

    updateRelease() {
      this.$emit("loader", true);
      this.$emit('uploads',true);
      let gameId = this.$route.params.gameId.toString();

      if (gameId !== "" && this.userData !== "" && this.jwtToken !== "") {
        let gameReleaseFile = this.getReleaseImageInput();
        let formData = new FormData();

        if (this.gameRelease.ReleaseName !== "") {
          formData.append("ReleaseName", this.gameRelease.ReleaseName);
        }

        if (this.gameRelease.Version !== "") {
          formData.append("Version", this.gameRelease.Version);
        }

        if (this.gameRelease.ReleaseNotes !== "") {
          formData.append("ReleaseNotes", this.gameRelease.ReleaseNotes);
        }

        if (gameReleaseFile !== null || gameReleaseFile !== undefined) {
          formData.append("PackageStream", gameReleaseFile);
        }

        formData.append("Platform", this.selectedTab=='web'?'WebGL':'Android');

        this.isSaving = "Saving...";

        GameReleaseService.createGameRelease(gameId, this.userData.userId, this.jwtToken, formData)
          .then((response: ResponseData) => {
            this.isSaving = "Save";
            this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
            this.getGameReleases();
            this.$emit('uploads',false);
            this.$emit('loader', false);

            Helper.toastSuccessHandling(response.data['message']);
            this.gameReleaseSelected = 'releases';
            this.gameRelease.ReleaseName = '';
            this.gameRelease.Version = '';
            this.gameRelease.ReleaseNotes = '';
            this.removeFile();
          }).catch((error) => {
            this.isSaving = 'Save';
            this.$emit('uploads',false);
            this.$emit('loader', false);

            Helper.endpointErrorHandling(error);
          });
      }
    },

    updateOnboardingChecklist(userId: string, token: string) {
      OnboardingChecklistService.getOnboardingChecklist(userId, token)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, 7, userId, token);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    },

    getFeedbackList() {
      let gameId = this.$route.params.gameId.toString();
      if (gameId !== "" && this.userData !== "" && this.jwtToken !== "") {
        FeedbackService.getFeedbackList(this.userData.userId, gameId).then((response: ResponseData) => {
          if (response.status === 200) {
            this.feedbackList = response.data;
            this.feedbackList.forEach(function (feedback: any) {
              feedback.timeCreated = Helper.formatDate(feedback.created);
              feedback.dateCreated = Helper.formatTime(feedback.created);
            });
          }
        });
      }
    },

    deleteReleaseSucess(){
      this.getGameReleases();
      this.displayConfirmDeleteModal = false;
    }
  },

  computed: {
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
  },

  mounted() {
    this.getGameReleases();
    this.getFeedbackList();
  },
});
